<template>
  <div id="A0" class="sub">
    <!-- ローディングモーダル -->
    <kg-loading-modal ref="loadingModalRef" />
    <div class="wrapper">
      <kg-header :headerType=1 />
      <div class="inner_static">
        <div id="news_detail_div">
          <h1 class="tit1">見積書確認</h1>
          <ul class="lst_register underline_ul">
            <!-- TODO 他に表示する情報確認 -->
            <li>
              <div class="title_text_div">
                <label>{{orderInfo.productName}}</label>
              </div>
              <div class="cnt">
                <p class="text_p">注文番号：<strong class="req">{{formatOrderNo(orderInfo.orderNo)}}</strong></p>
                <section class="sec_space">
                  <ul class="lst_space">
                    <li v-for="(combine,index) in orderInfo.combineList" :key="index">
                        <span class="combine_span" @click="btnCombineClick('unit_wrap' + index)">
                          <div>
                            <div class="fl_input small_input">
                              <img class="combine_img" :src="getCombineImage(combine)" @error="noImage" alt="planContents">
                            </div>
                            <div class="fl_input input_interval_div">&nbsp;&nbsp;&nbsp;</div>
                            <div class="fl_input">
                              <div>{{combine.objDtlTypeName}}</div>
                              <div><strong class="req">W:&nbsp;</strong>{{combine.w}}<strong class="req">&nbsp;H:&nbsp;</strong>{{combine.h}}<strong class="req">&nbsp;D:&nbsp;</strong>{{combine.d}}</div>
                              <div>{{formatPrice(roundPrice(combine.objTotalCostMaterial))}}</div>
                            </div>
                            <div class="cb"></div>
                          </div>
                        </span>
                      <div class="unit_wrap" v-bind:id="'unit_wrap' + index">
                        <!-- <div class="answer_wrap" v-bind:id="faq.key + index"> -->
                        <div v-for="(unit,i) in orderInfo.unitList" :key="i" >
                          <div v-if="combine.lvCombine === unit.lvCombine">
                            <div class="fl_input pair_input unit_tx">{{unit.objDtlTypeName}}</div>
                            <div class="pair_input_interval_div fl_input"></div>
                            <div class="fl_input ta_right pair_input unit_tx">{{formatPrice(roundPrice(unit.objTotalCostMaterial)) + ' × ' + '1' + ' = ' + formatPrice(roundPrice(unit.objTotalCostMaterial))}}</div>
                            <div class="cb"></div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </section>
                <p class="text_p">生産者情報：</p>
                <p class="text_p">{{orderInfo.producerName}}</p>
                <p class="text_p">{{orderInfo.producerAddress}}</p>
                <div class="subtotal_div">
                  <label>小計</label><div class="subtotal">{{formatPrice(orderInfo.subTotalPrice)}}</div>
                </div>
              </div>
            </li>
            <li>
              <div class="item">
                <label>【オプションサービス】</label>
              </div>
              <div v-if="checkedOption.length <= 0">
                なし
              </div>
              <div v-else v-for="(optionService, i) in checkedOption" :key="i">
                <div class="fl_input">{{optionService.optionName}}</div>
                <div class="ta_right">{{formatPrice(optionService.price)}}</div>
              </div>
              <div class="subtotal_div">
                <label>小計</label><div class="subtotal">{{formatPrice(optionPriceTotal)}}</div>
                <!-- <label>小計</label><div class="subtotal">{{formatPrice(orderInfo.opPrice)}}</div> -->
              </div>
            </li>
            <!-- TODO カグルユーザーは下記の情報を持っていない -->
<!--            <li>-->
<!--              <div class="item">-->
<!--                <label>【発注者】</label>-->
<!--              </div>-->
<!--              <div class="cnt">-->
<!--                <div class="confirm_item_name_div">-->
<!--                  <div class="confirm_item_name"><span>発注者企業名：</span></div>-->
<!--                  <div class="confirm_item_name"><span>郵便番号：</span></div>-->
<!--                  <div class="confirm_item_name"><span>発注者住所：</span></div>-->
<!--                  <div class="confirm_item_name"><span>以下、住所：</span></div>-->
<!--                  <div class="confirm_item_name"><span>発注者氏名：</span></div>-->
<!--                  <div class="confirm_item_name"><span>（カナ）：</span></div>-->
<!--                  <div class="confirm_item_name"><span>電話番号：</span></div>-->
<!--                </div>-->
<!--                <div>-->
<!--                  <div class="confirm_item_value">-->
<!--                    {{userInfo.corpName}}-->
<!--                  </div>-->
<!--                  <div class="confirm_item_value">-->
<!--                    {{userInfo.postcd}}-->
<!--                  </div>-->
<!--                  <div class="confirm_item_value">-->
<!--                    {{userInfo.state}}{{userInfo.city}}-->
<!--                  </div>-->
<!--                  <div class="confirm_item_value">-->
<!--                    {{userInfo.street}}-->
<!--                  </div>-->
<!--                  <div class="confirm_item_value">-->
<!--                    {{userInfo.userLastName}}{{userInfo.userFirstName}}-->
<!--                  </div>-->
<!--                  <div class="confirm_item_value">-->
<!--                    {{userInfo.userLastNameKana}}{{userInfo.userFirstNameKana}}-->
<!--                  </div>-->
<!--                  <div class="confirm_item_value">-->
<!--                    {{userInfo.tel}}-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </li>-->
            <li>
              <div class="item">
                <label>【お届け先】</label>
              </div>
              <div class="cnt">
                <div class="confirm_item_name_div">
                  <div class="confirm_item_name"><span>郵便番号：</span></div>
                  <div class="confirm_item_name"><span>都道府県：</span></div>
                  <div class="confirm_item_name"><span>住所：</span></div>
                  <div class="confirm_item_name"><span>携帯電話番号：</span></div>
                  <div class="confirm_item_name"><span>日中ご連絡のとれる電話番号：</span></div>
                  <div class="confirm_item_name"><span>お名前(漢字)：</span></div>
                  <div class="confirm_item_name"><span>お名前(カナ)：</span></div>
                  <div class="confirm_item_name"><span>設置場所の階数：</span></div>
                  <div class="confirm_item_name"><span>エレベーター：</span></div>
                  <div class="confirm_item_name"><span>駐車スペース：</span></div>
                  <div class="confirm_item_name"><span>家具の引き取り：</span></div>
                </div>
                <div>
                  <div class="confirm_item_value">
                    {{orderInput.postcd1}}-{{orderInput.postcd2}}
                  </div>
                  <div class="confirm_item_value">
                    {{orderInput.prefecture}}
                  </div>
                  <div class="confirm_item_value">
                    {{orderInput.address1}}{{orderInput.address2}}{{orderInput.address3}}
                  </div>
                  <div class="confirm_item_value">
                    {{orderInput.cellphoneNo1}}-{{orderInput.cellphoneNo2}}-{{orderInput.cellphoneNo3}}
                  </div>
                  <div class="confirm_item_value">
                    {{orderInput.contactphoneNo1}}-{{orderInput.contactphoneNo2}}-{{orderInput.contactphoneNo3}}
                  </div>
                  <div class="confirm_item_value">
                    {{orderInput.deliLastName}}&nbsp;{{orderInput.deliFirstName}}
                  </div>
                  <div class="confirm_item_value">
                    {{orderInput.deliLastNameKana}}&nbsp;{{orderInput.deliFirstNameKana}}
                  </div>
                  <div class="confirm_item_value">
                    {{orderInput.floor}}階
                  </div>
                  <div class="confirm_item_value">
                    {{formatYesOrNo(orderInput.elevator)}}
                  </div>
                  <div class="confirm_item_value">
                    {{formatYesOrNo(orderInput.deliParkingSpace)}}
                  </div>
                  <div class="confirm_item_value">
                    {{formatYesOrNo(orderInput.deliDisposal)}}
                  </div>
                </div>
              </div>
              <div class="subtotal_div">
                <label>搬送搬入費用</label><div class="subtotal">{{formatPrice(orderInfo.deliveryPrice)}}</div>
              </div>
            </li>
            <li>
              <div class="item">
                <label>【合計】</label>
              </div>
              <div>
                <div class="fl_input">プラン</div>
                <div class="ta_right">{{formatPrice(orderInfo.subTotalPrice)}}</div>
                <div class="fl_input">オプションサービス</div>
                <div class="ta_right">{{formatPrice(optionPriceTotal)}}</div>
                <div class="fl_input">搬送搬入費用</div>
                <div class="ta_right">{{formatPrice(orderInfo.deliveryPrice)}}</div>
                <div class="fl_input">消費税（10%）</div>
                <div class="ta_right">{{formatPrice(taxPrice)}}</div>
              </div>
              <div class="subtotal_div">
                <label>合計</label><div class="subtotal">{{formatPrice(priceTotal)}}</div>
              </div>
            </li>
            <li>
              <div class="item">
                <label>【お届け希望日】</label>
              </div>
              <div>{{getViewDate(orderInput.deliveryPref)}}</div>
            </li>
            <li>
              <div class="item">
                <label>【組み立て作業希望日】</label>
              </div>
              <div class="cnt">
                <div class="confirm_item_name_div">
                  <div class="confirm_item_name"><span>第一希望：</span></div>
                  <div class="confirm_item_name"><span>第二希望：</span></div>
                  <div class="confirm_item_name"><span>第三希望：</span></div>
                </div>
                <div>
                  <div class="confirm_item_value">
                    {{getViewDate(orderInput.btPref1)}}
                  </div>
                  <div class="confirm_item_value">
                    {{getViewDate(orderInput.btPref2)}}
                  </div>
                  <div class="confirm_item_value">
                    {{getViewDate(orderInput.btPref3)}}
                  </div>
                </div>
              </div>
            </li>
          </ul>
          <div class="btn_area">
            <a class="btn1" @click="payment()">お支払い方法選択</a>
          </div>
        </div>
        <form name="ecform" :action="ecsiteUrl" method="post" accept-charset="Shift_JIS">
          <!-- <h4>EC接続テスト</h4> -->
          <div>
            <input type="hidden" name="in_kamei_id" v-bind:value="ecData.in_kamei_id">
            <input type="hidden" name="in_n" v-bind:value="ecData.in_n">
            <input type="hidden" name="in_redirecturl_ok" v-bind:value="ecData.in_redirecturl_ok">
            <input type="hidden" name="in_redirecturl_ng" v-bind:value="ecData.in_redirecturl_ng">
            <input type="hidden" name="in_redirecturl_can" v-bind:value="ecData.in_redirecturl_can">
            <input type="hidden" name="in_shori_kbn" v-bind:value="ecData.in_shori_kbn">
            <input type="hidden" name="in_moushikomi_kbn01" v-bind:value="ecData.in_moushikomi_kbn01">
            <input type="hidden" name="in_moushikomi_kbn02" v-bind:value="ecData.in_moushikomi_kbn02">
            <input type="hidden" name="in_kingaku" v-bind:value="ecData.in_kingaku">
            <input type="hidden" name="in_zei_kbn" v-bind:value="ecData.in_zei_kbn">
            <input type="hidden" name="in_mail_syu" v-bind:value="ecData.in_mail_syu">
            <input type="hidden" name="in_kyaku_mail" v-bind:value="ecData.in_kyaku_mail">
            <input type="hidden" name="in_keitai_sosin_flg" v-bind:value="ecData.in_keitai_sosin_flg">
            <input type="hidden" name="in_skigen_bango" v-bind:value="ecData.in_skigen_bango">
            <input type="hidden" name="in_kokyaku_id" v-bind:value="ecData.in_kokyaku_id">
            <input type="hidden" name="in_chumon_no" v-bind:value="ecData.in_chumon_no">
            <input type="hidden" name="in_tokushu1" v-bind:value="ecData.in_tokushu1">
            <input type="hidden" name="in_shiharai_kbn" v-bind:value="ecData.in_shiharai_kbn">
            <input type="hidden" name="in_tskbn" v-bind:value="ecData.in_tskbn">
            <input type="hidden" name="in_keyaku_kbn" v-bind:value="ecData.in_keyaku_kbn">
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import * as App from '../../utils/App'
import {KG_STORAGE_KEY, KG_URL} from '../../constants/App'
import * as Calc from '../../utils/Calc'
import * as FormUtil from '../../utils/FormUtil'
import axios from 'axios'

// Kagull Module
import Header from '../components/common/HomeIconHeader'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  components: {
    'kg-header': Header,
    'kg-loading-modal': LoadingModal
  },
  data () {
    return {
      userInfo: {},
      orderInfo: {},
      orderInput: {},
      optionServiceList: [],
      ecData: {},
      ecsiteUrl: ''
    }
  },
  methods: {
    init: function () {
      this.orderInfo = App.getLocalStorage(KG_STORAGE_KEY.ORDER_INFO)
      this.orderInput = App.getLocalStorage(KG_STORAGE_KEY.ORDER_INPUT)
      this.userInfo = App.getLocalStorage(KG_STORAGE_KEY.USER_INFO)
      // TODO ストレージじゃなくてAPI叩いた方がいい？
      this.optionServiceList = App.getLocalStorage(KG_STORAGE_KEY.OPTION_SERVICE_LIST)
      if (this.orderInfo == null || Object.keys(this.orderInfo).length <= 0 ||
        this.orderInput == null || Object.keys(this.orderInput).length <= 0) {
        this.$router.push({
          name: 'KgError'
        })
      }
    },
    getCombineImage: function (combine) {
      let combineContents = this.orderInfo.combineContentsList.find(combineContents => {
        return combineContents.umCode === combine.objUmCode
      })
      return combineContents != null
        ? App.getContentsResource(combineContents.corpId + '/' + combineContents.contentsImgMid)
        : App.getKagullResource('noimage.svg')
    },
    noImage: function (element) {
      element.target.src = App.getKagullResource('noimage.svg')
    },
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    // プラン情報で使用
    btnCombineClick: function (targetId) {
      // ユニット情報の表示非表示切り替え
      let target = document.getElementById(targetId)
      if (target.style.display === 'block') {
        target.style.display = 'none'
      } else {
        target.style.display = 'block'
      }
      if (target.parentElement.classList.contains('active')) {
        target.parentElement.classList.remove('active')
      } else {
        target.parentElement.classList.add('active')
      }
    },
    formatOrderNo: function (orderNo) {
      if (!orderNo) return ''
      return orderNo.substring(0, 3) + '-' + orderNo.substring(3, 7) + '-' + orderNo.substring(8)
    },
    roundPrice: function (value) {
      return Calc.round(value, 0)
    },
    // ここまで：プラン情報で使用
    // 発注先
    formatYesOrNo: function (value) {
      return value === true || value === 'true' ? 'あり' : 'なし'
    },
    // ここまで：発注先
    // お届け希望日
    getViewDate: function (date) {
      return FormUtil.getViewDate(date)
    },
    // ここまで：お届け希望日
    payment: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        optionServices: this.orderInput.optionServices,
        opPrice: this.optionPriceTotal, // TODO サーバーサイドで計算する？
        deliPostcd: this.postcd,
        deliState: this.orderInput.prefecture,
        deliCity: this.orderInput.address1,
        deliStreet: this.orderInput.address2,
        deliBuilding: this.orderInput.address3,
        deliCellPhoneNo: this.cellphoneNo,
        deliTel: this.contactphoneNo,
        deliLastName: this.orderInput.deliLastName,
        deliFirstName: this.orderInput.deliFirstName,
        deliLastNameKana: this.orderInput.deliLastNameKana,
        deliFirstNameKana: this.orderInput.deliFirstNameKana,
        deliFloor: this.orderInput.floor,
        deliElevator: this.orderInput.elevator,
        deliParkingSpace: this.orderInput.deliParkingSpace,
        deliDisposal: this.orderInput.deliDisposal,
        deliPref: this.orderInput.deliveryPref,
        // deliPref: this.yyyyMMddDeliPref,
        deliPrefTime: this.orderInput.deliveryTime,
        btPref1: this.orderInput.btPref1,
        // btPref1: this.yyyyMMddBtPref1,
        btPref1Time: this.orderInput.btPref1Time,
        btPref2: this.orderInput.btPref2,
        // btPref2: this.yyyyMMddBtPref2,
        btPref2Time: this.orderInput.btPref2Time,
        btPref3: this.orderInput.btPref3,
        // btPref3: this.yyyyMMddBtPref3,
        btPref3Time: this.orderInput.btPref3Time
      }

      // 決済画面へ
      axios.post(KG_URL.ORDER + '/payment', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
            this.$refs.loadingModalRef.showModal(false)
          } else {
            this.ecData = response.data.data
            this.ecsiteUrl = this.ecData.ecsiteUrl
            // 決済が返ってきたら、vuejsからformをsubmit
            this.$nextTick(function () {
              if (this.ecsiteUrl) {
                // // IEはformの文字コード指定でaccept-charsetが効かない事から独自対応をする
                // if (Check.isBrawserIE()) {
                // document.charset = 'SHIFT_JIS'
                // }
                document.ecform.submit()
              } else {
                // TODO kagullエラーページに遷移
                // this.$router.push('/mmstyle/error')
              }
            })
          }
          // }).catch(error => {
        }).catch(error => {
          // this.validateErrorMessages = {}
          // Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          // this.$router.push('/mmstyle/error')
          App.showModal({
            messages: ['アクセスが集中しており、通信に失敗いたしました。恐れ入りますが、もう一度お試しください。'],
            messageType: 'error',
            onOk: () => {
            }
          })
          console.log(error)
          this.$refs.loadingModalRef.showModal(false)
        }).finally(() => {
          this.paymentFlag = false
        })
    }
  },
  computed: {
    // オプション
    checkedOption: function () {
      if (this.optionServiceList != null && this.optionServiceList.length !== 0 &&
          Object.keys(this.orderInput.optionServices).length !== 0) {
        return this.optionServiceList.filter(e => this.orderInput.optionServices.includes(e.key))
      }
      return []
    },
    optionPriceTotal: function () {
      // オプションサービスのチェックに応じて小計を計算する
      if (this.optionServiceList != null && this.optionServiceList.length !== 0 &&
          Object.keys(this.orderInput.optionServices).length !== 0) {
        let temp = this.optionServiceList
          .filter(e => this.orderInput.optionServices.includes(e.key))
          .map(e => e.price)
        if (Object.keys(temp).length !== 0) {
          return temp.reduce(function (p, c) { return p + c })
        }
      }
      return 0
    },
    // ここまで：オプション
    // 消費税
    taxPrice: function () {
      let price = this.orderInfo.subTotalPrice + this.optionPriceTotal + this.orderInfo.deliveryPrice
      return Math.ceil(price * 0.1)
    },
    // 合計
    // TODO 金額関連要確認
    priceTotal: function () {
      // 合計金額を計算する
      return this.orderInfo.subTotalPrice + this.optionPriceTotal + this.orderInfo.deliveryPrice + this.taxPrice
    },
    // ここまで：合計
    // オーダークリック
    postcd: function () {
      // 郵便番号を連結して返す
      return this.orderInput.postcd1 + this.orderInput.postcd2
    },
    cellphoneNo: function () {
      // 携帯電話番号を連結して返す
      return this.orderInput.cellphoneNo1 + this.orderInput.cellphoneNo2 + this.orderInput.cellphoneNo3
    },
    contactphoneNo: function () {
      // 連絡用電話番号を連結して返す
      return this.orderInput.contactphoneNo1 + this.orderInput.contactphoneNo2 + this.orderInput.contactphoneNo3
    }
    // ここまで：オーダークリック
  },
  created: function () {
    this.init()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/OrderConfirm.vue